import { useParams } from 'react-router-dom'

import CompanySubDivisionProfile from '../containers/companies/SubDivisionProfile'

const CompanySubDivision = () => {
  const { companyId, divId, subDivId } = useParams<{ companyId: string, divId: string, subDivId: string }>()
  if(!companyId || !divId || !subDivId) { return <div>Invalid params</div> }
  return (
    <div className='mb-14 sm:mb-20'>
      <CompanySubDivisionProfile companyId={parseInt(companyId)} divisionId={parseInt(divId)} subDivisionId={parseInt(subDivId)} />
    </div>
  )
}

export default CompanySubDivision
